import { render, staticRenderFns } from "./HomeSkeleton.vue?vue&type=template&id=575214e5"
import script from "./HomeSkeleton.vue?vue&type=script&lang=js"
export * from "./HomeSkeleton.vue?vue&type=script&lang=js"
import style0 from "./HomeSkeleton.vue?vue&type=style&index=0&id=575214e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports